import { Component, OnInit, Injectable } from '@angular/core';
import { Subject, fromEvent, BehaviorSubject, timer } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class LayoutService {
	pageLoading = true;
	pageLoading$ = new BehaviorSubject<Boolean>(true);
	timeout = 400;

	setPageLoading(isLoad: boolean): void {
		if (isLoad === true) timer(0).subscribe(() => this.pageLoading$.next(isLoad));
		if (isLoad === false) {
			timer(this.timeout).subscribe(() => this.pageLoading$.next(isLoad));
		}
	}
}
